import { ThreeDotsLoader } from "../../../../../components";

const ReanalyzeFormInputLoadingIndicator = () => (
  <>
    <ThreeDotsLoader height={6} /> Loading
  </>
);

export default ReanalyzeFormInputLoadingIndicator;
